import { WorkflowService } from './../../../../../services/workflow.service';
import {
  Component,
  OnInit,
  ComponentFactoryResolver,
  Input,
  Inject,
  forwardRef,
  AfterViewInit,
  ChangeDetectorRef
} from '@angular/core';
import { DataEntityInputComponent } from '../../data-entity-input/data-entity-input.component';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { FeeDataEntity } from '../../../../../models/data-entities';
import {
  SecurityService,
  WorkflowContextService
} from '../../../../../services';
import { CalcOnChangeDataEntityComponent } from '../../data-entity-input/calc-on-change-data-entity';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-fee-data-entity-input',
    templateUrl: './fee-data-entity-input.component.html',
    styleUrls: ['./fee-data-entity-input.component.css'],
    standalone: false
})
export class FeeDataEntityInputComponent extends CalcOnChangeDataEntityComponent
  implements OnInit {
  @Input() entity: FeeDataEntity;
  @Input() isPreview: boolean;
  templateForPermitForm:boolean=false
  constructor(
    public layoutService: LayoutService,
    componentFactoryResolver: ComponentFactoryResolver,
    ref: ChangeDetectorRef,
    private _fb: UntypedFormBuilder,
    @Inject(forwardRef(() => SecurityService))
    securitySvc: SecurityService,
    @Inject(forwardRef(() => WorkflowService))
    workflowSvc: WorkflowService,
    @Inject(forwardRef(() => WorkflowContextService))
    context: WorkflowContextService
  ) {
    super(layoutService,componentFactoryResolver, workflowSvc, context, securitySvc, ref);
             //added by priya 22-12-2025

           layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
             //end by priya 22-12-2025
  }
}
